<template>
<Box @close="close({})" v-if="pedido_items">
    <template #top>
        Aprobar Pedido de Compra: {{ pedido_items.pei_id }}
    </template>
    <template #center>
        <div class="nj-panel">
            <div class="nj-panel-content">
                <div class="nj-grid">
                    <Info label="Proyecto">{{ pedido_items.pry_nombre }}</Info>
                    <Info label="Estado">{{ pedido_items.pei_estado_nombre }}</Info>
                    <Info label="Solicitante">{{ pedido_items.usu_solicitante_nombre }}</Info>
                    <Info label="Logistico">{{ pedido_items.usu_logistica_nombre }}</Info>
                    <Info label="Almacen destino">{{ pedido_items.alm_nombre }}</Info>
                    <Info label="Fecha registro">{{ pedido_items.pei_fecha_registro }}</Info>
                </div>
                <div class="nj-grid c1">
                    <Info label="Notas">{{ pedido_items.pei_notas }}</Info>
                </div>
                <br>
                <b-table :data="pedido_items.lista_pedido_items_detalle" style="width: 100%;">
                    <template slot-scope="props">
                        <b-table-column label="ID" header-class="is-info" style="width: 80px;">{{ props.row.prv_id }}</b-table-column>
                        <b-table-column label="Producto" header-class="is-info">{{ props.row.pid_producto }}</b-table-column>
                        <b-table-column label="Cant. solicitada" header-class="is-info" style="width: 120px">{{ props.row.pid_cantidad_solicitada }}</b-table-column>
                        <b-table-column label="Cant. aprobada" header-class="is-info" style="width: 120px">
                            <input type="text" class="nj-text right" v-model="props.row.pid_cantidad_aprobada" />
                        </b-table-column>
                    </template>
                </b-table>
            </div>
        </div>
    </template>
    <template #bottom>
        <Button icon="save" color="green" label="Aprobar" @click="aprobar()"></Button>
    </template>
</Box>
</template>
<script>
import { PedidoItemsService, ResponseStatus } from "../../services"
import { Confirm } from "../../util"
import Toast from "../../util/toast"
import { Box, Button, Info, InputSelect, InputText, InputTextarea, SearchBox } from "../components/"
export default {
    name: "AprobarPedidoItems",
    components: {
        Box,
        InputText,
        InputTextarea,
        InputSelect,
        Button,
        SearchBox,
        Info,
    },
    props: {
        pei_id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            pedido_items: null,
        }
    },
    methods: {
        close({
            interfaz = "",
            buscar = false
        }) {
            this.$emit("close", {
                interfaz,
                buscar,
            })
        },
        aprobar() {
            Confirm.show({
                message: "¿Desea aprobar el pedido de items?",
                action: () => {
                    let pedido_items = {
                        pei_id: this.pedido_items.pei_id,
                        lista_pedido_items_detalle: []
                    }
                    this.pedido_items.lista_pedido_items_detalle.forEach(item => {
                        let _item = {
                            pid_id: item.pid_id,
                            pid_cantidad_aprobada: item.pid_cantidad_aprobada,
                        }
                        pedido_items.lista_pedido_items_detalle.push(_item)
                    })
                    PedidoItemsService
                        .aprobar({
                            pedido_items
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.close({
                                    buscar: true
                                })
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
            })
        },
    },
    mounted() {
        // obteniendo el pedido
        PedidoItemsService
            .obtener({
                pedido_items: {
                    pei_id: this.pei_id
                }
            })
            .then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.pedido_items = response.data
                    this.pedido_items.lista_pedido_items_detalle.forEach(item => {
                        item.pid_cantidad_aprobada = item.pid_cantidad_solicitada
                    })
                }
                else {
                    Toast.error(response.message)
                }
            })
            .catch(error => {
                Toast.error(error)
            })
    }
}
</script>

<style scoped></style>